import {
  goalInboxID,
  ID,
  ReorderItem,
  ReorderResult,
  Task,
  TaskListItemTypes,
} from '@griply/types';
import cloneDeep from 'lodash/cloneDeep';

import { filterReorderableChildIds } from './filter-reorderable-child-ids';
import { findParentItem } from './find-parent-item';

export type OnGoalReorderOptions = {
  updatedItems: readonly ReorderItem[];
  oldItems: readonly ReorderItem[];
  tasksMap: Record<ID, Task>;
  rootSectionId: ID;
};

export const onGoalReorder = ({
  updatedItems,
  oldItems,
  tasksMap,
  rootSectionId,
}: OnGoalReorderOptions): ReorderResult => {
  const updatedTasks: Task[] = [];
  const updatedSections: ReorderResult['updatedSections'] = [];

  updatedItems.forEach((item) => {
    if (item.type === TaskListItemTypes.Task) {
      if (!tasksMap[item.id]) {
        return;
      }

      const taskToUpdate = cloneDeep(tasksMap[item.id]);
      const parentItem =
        findParentItem(updatedItems, item.id) ??
        findParentItem(oldItems, item.id);

      const goalId =
        !parentItem?.id || parentItem.id === goalInboxID ? null : parentItem.id;

      taskToUpdate.goalId = goalId;

      if (goalId) {
        taskToUpdate.lifeAreaId = null;
      }

      updatedTasks.push(taskToUpdate);
      return;
    }

    if (item.type === TaskListItemTypes.Root) {
      updatedSections.push({
        id: rootSectionId,
        taskSorting: filterReorderableChildIds(item.children),
      });
      return;
    }

    if (item.type === TaskListItemTypes.Goal) {
      updatedSections.push({
        id: item.id,
        taskSorting: filterReorderableChildIds(item.children),
      });
    }
  });

  return { updatedSections, updatedTasks };
};
